export const STAKING_SCHEDULED = Symbol('STAKING_SCHEDULED')
export const STAKING_CHALLENGED = Symbol('STAKING_CHALLENGED')
export const STAKING_COMPLETED = Symbol('STAKING_COMPLETED')
export const STAKING_CANCELLED = Symbol('STAKING_CANCELLED')
export const STAKING_SETTLED = Symbol('STAKING_SETTLED')

export const COLLATERAL_LOCKED = Symbol('COLLATERAL_LOCKED')
export const COLLATERAL_CHALLENGED = Symbol('COLLATERAL_CHALLENGED')
export const COLLATERAL_AVAILABLE = Symbol('COLLATERAL_AVAILABLE')
export const COLLATERAL_SLASHED = Symbol('COLLATERAL_SLASHED')

export const STAKING_STATUSES = new Map([
  ['Scheduled', STAKING_SCHEDULED],
  ['Settled', STAKING_SETTLED],
  ['Challenged', STAKING_CHALLENGED],
  ['Completed', STAKING_COMPLETED],
  ['Cancelled', STAKING_CANCELLED],
])

export const COLLATERAL_STATUSES = new Map([
  ['Locked', COLLATERAL_LOCKED],
  ['Challenged', COLLATERAL_CHALLENGED],
  ['Available', COLLATERAL_AVAILABLE],
  ['Slashed', COLLATERAL_SLASHED],
])
